export const getLongDate = (input?: string | Date): string => {
  if (!input) return "";

  // Convert string to Date if needed
  const date = input instanceof Date ? input : new Date(input);

  if (isNaN(date.getTime())) return ""; // invalid date check

  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  const month = date.toLocaleDateString("en-GB", {
    month: "long",
    timeZone: "UTC"
  });

  // Add ordinal suffix (st, nd, rd, th)
  const getOrdinal = (n: number): string => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${day}${getOrdinal(day)} ${month} ${year}`;
};
